// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddVideoChapter_container__Ihigx {
    padding: 24px;
    background-color: #121212;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    margin-bottom: 20px;
    color: #f5f5f5;
  }
  
   
  .AddVideoChapter_title__kZ7Ub {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 24px;
    color: #ffffff;
    border-bottom: 2px solid #ff3333;
    padding-bottom: 10px;
  }
  
  .AddVideoChapter_form__USpJn {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .AddVideoChapter_formGroup__NL2se {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .AddVideoChapter_label__mdE5Y {
    font-weight: 500;
    font-size: 0.95rem;
    color: #cccccc;
  }
  
  .AddVideoChapter_input__T7ZHt, .AddVideoChapter_select__JR5JB {
    padding: 10px 14px;
    border-radius: 6px;
    border: 1px solid #333333;
    background-color: #1e1e1e;
    color: #f0f0f0;
    font-size: 1rem;
    transition: all 0.2s ease;
  }
  
  .AddVideoChapter_input__T7ZHt:focus, .AddVideoChapter_select__JR5JB:focus {
    outline: none;
    border-color: #ff333300
  }
  
  .AddVideoChapter_select__JR5JB option {
    background-color: #1e1e1e;
    color: #f0f0f0;
  }
  
  .AddVideoChapter_submitButton__ccYuc {
    background-color: #ff3333;
    color: white;
    padding: 12px;
    border-radius: 6px;
    border: none;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    margin-top: 10px;
  }
  
  .AddVideoChapter_submitButton__ccYuc:hover {
    background-color: #e61919;
  }
  
  .AddVideoChapter_submitButton__ccYuc:disabled {
    background-color: #666666;
    cursor: not-allowed;
  }
  
  .AddVideoChapter_loading__FfzBx, .AddVideoChapter_error__PnnAg {
    padding: 20px;
    border-radius: 6px;
    font-weight: 500;
  }
  
  .AddVideoChapter_loading__FfzBx {
    background-color: #1e1e1e;
    color: #aaaaaa;
  }
  
  .AddVideoChapter_error__PnnAg {
    background-color: #3d0404;
    color: #ff8080;
  }
  
  .AddVideoChapter_message__LO8Ve {
    padding: 12px;
    border-radius: 6px;
    font-weight: 500;
  }
  
  .AddVideoChapter_success__j6tNG {
    background-color: #0a2c0a;
    color: #7fff7f;
  }
  
  .AddVideoChapter_error__PnnAg {
    background-color: #3d0404;
    color: #ff8080;
  }
  
  .AddVideoChapter_previewCard__2zZFR {
    background-color: #1e1e1e;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #333333;
  }
  
  .AddVideoChapter_previewTitle__nlDt6 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 12px;
    color: #ff6666;
  }
  
  .AddVideoChapter_videoPreview__ZRurq {
    display: flex;
    gap: 15px;
  }
  
  .AddVideoChapter_videoImage__LdHWb {
    flex: 0 0 120px;
  }
  
  .AddVideoChapter_previewImg__4mmSa {
    width: 100%;
    border-radius: 4px;
    object-fit: cover;
    aspect-ratio: 16/9;
  }
  
  .AddVideoChapter_videoDetails__lxKB6 {
    flex: 1 1;
  }
  
  .AddVideoChapter_videoDetails__lxKB6 p {
    margin: 5px 0;
  }
  /* Searchable Select Wrapper */
.AddVideoChapter_searchableSelect__0mnZv {
  position: relative;
  display: flex;
  align-items: center;
  background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.AddVideoChapter_searchableSelect__0mnZv:hover {
  border-color: #ff3333;
}

.AddVideoChapter_searchableSelect__0mnZv input {
  flex-grow: 1;
  background: transparent;
  border: none;
  color: #f0f0f0;
  font-size: 1rem;
  outline: none;
  width: 100%;
}

.AddVideoChapter_searchableSelect__0mnZv .AddVideoChapter_dropdownArrow__O2Nqt {
  margin-left: 8px;
  font-size: 14px;
  color: #ff6666;
  transition: transform 0.2s ease;
}

.AddVideoChapter_searchableSelect__0mnZv.AddVideoChapter_open__l4nWg .AddVideoChapter_dropdownArrow__O2Nqt {
  transform: rotate(180deg);
}

/* Dropdown List */
.AddVideoChapter_dropdownList__7Kc8U {
 background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 6px;
  margin-top: 5px;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: AddVideoChapter_fadeIn__Mx5mV 0.2s ease-in-out;
}

.AddVideoChapter_dropdownItem__uRQc1 {
  padding: 10px 14px;
  font-size: 1rem;
  color: #f0f0f0;
  transition: background 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.AddVideoChapter_dropdownItem__uRQc1:hover {
  background-color: #ff3333;
  color: #ffffff;
}

.AddVideoChapter_dropdownItem__uRQc1:empty {
  color: #888888;
  text-align: center;
}

.AddVideoChapter_dropdownList__7Kc8U::-webkit-scrollbar {
  width: 6px;
}

.AddVideoChapter_dropdownList__7Kc8U::-webkit-scrollbar-thumb {
  background: #ff3333;
  border-radius: 4px;
}

.AddVideoChapter_dropdownList__7Kc8U::-webkit-scrollbar-track {
  background: #222222;
}

@keyframes AddVideoChapter_fadeIn__Mx5mV {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/Series/AddVideoChapter.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;EAChB;;;EAGA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb;EACF;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,aAAa;EACf;EACA,8BAA8B;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;CACC,yBAAyB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,yDAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n    padding: 24px;\n    background-color: #121212;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    margin-bottom: 20px;\n    color: #f5f5f5;\n  }\n  \n   \n  .title {\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    color: #ffffff;\n    border-bottom: 2px solid #ff3333;\n    padding-bottom: 10px;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .formGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .label {\n    font-weight: 500;\n    font-size: 0.95rem;\n    color: #cccccc;\n  }\n  \n  .input, .select {\n    padding: 10px 14px;\n    border-radius: 6px;\n    border: 1px solid #333333;\n    background-color: #1e1e1e;\n    color: #f0f0f0;\n    font-size: 1rem;\n    transition: all 0.2s ease;\n  }\n  \n  .input:focus, .select:focus {\n    outline: none;\n    border-color: #ff333300\n  }\n  \n  .select option {\n    background-color: #1e1e1e;\n    color: #f0f0f0;\n  }\n  \n  .submitButton {\n    background-color: #ff3333;\n    color: white;\n    padding: 12px;\n    border-radius: 6px;\n    border: none;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    margin-top: 10px;\n  }\n  \n  .submitButton:hover {\n    background-color: #e61919;\n  }\n  \n  .submitButton:disabled {\n    background-color: #666666;\n    cursor: not-allowed;\n  }\n  \n  .loading, .error {\n    padding: 20px;\n    border-radius: 6px;\n    font-weight: 500;\n  }\n  \n  .loading {\n    background-color: #1e1e1e;\n    color: #aaaaaa;\n  }\n  \n  .error {\n    background-color: #3d0404;\n    color: #ff8080;\n  }\n  \n  .message {\n    padding: 12px;\n    border-radius: 6px;\n    font-weight: 500;\n  }\n  \n  .success {\n    background-color: #0a2c0a;\n    color: #7fff7f;\n  }\n  \n  .error {\n    background-color: #3d0404;\n    color: #ff8080;\n  }\n  \n  .previewCard {\n    background-color: #1e1e1e;\n    border-radius: 8px;\n    padding: 16px;\n    border: 1px solid #333333;\n  }\n  \n  .previewTitle {\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin-bottom: 12px;\n    color: #ff6666;\n  }\n  \n  .videoPreview {\n    display: flex;\n    gap: 15px;\n  }\n  \n  .videoImage {\n    flex: 0 0 120px;\n  }\n  \n  .previewImg {\n    width: 100%;\n    border-radius: 4px;\n    object-fit: cover;\n    aspect-ratio: 16/9;\n  }\n  \n  .videoDetails {\n    flex: 1;\n  }\n  \n  .videoDetails p {\n    margin: 5px 0;\n  }\n  /* Searchable Select Wrapper */\n.searchableSelect {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.searchableSelect:hover {\n  border-color: #ff3333;\n}\n\n.searchableSelect input {\n  flex-grow: 1;\n  background: transparent;\n  border: none;\n  color: #f0f0f0;\n  font-size: 1rem;\n  outline: none;\n  width: 100%;\n}\n\n.searchableSelect .dropdownArrow {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #ff6666;\n  transition: transform 0.2s ease;\n}\n\n.searchableSelect.open .dropdownArrow {\n  transform: rotate(180deg);\n}\n\n/* Dropdown List */\n.dropdownList {\n background-color: #1e1e1e;\n  border: 1px solid #333333;\n  border-radius: 6px;\n  margin-top: 5px;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.dropdownItem {\n  padding: 10px 14px;\n  font-size: 1rem;\n  color: #f0f0f0;\n  transition: background 0.2s ease, color 0.2s ease;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: #ff3333;\n  color: #ffffff;\n}\n\n.dropdownItem:empty {\n  color: #888888;\n  text-align: center;\n}\n\n.dropdownList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdownList::-webkit-scrollbar-thumb {\n  background: #ff3333;\n  border-radius: 4px;\n}\n\n.dropdownList::-webkit-scrollbar-track {\n  background: #222222;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddVideoChapter_container__Ihigx`,
	"title": `AddVideoChapter_title__kZ7Ub`,
	"form": `AddVideoChapter_form__USpJn`,
	"formGroup": `AddVideoChapter_formGroup__NL2se`,
	"label": `AddVideoChapter_label__mdE5Y`,
	"input": `AddVideoChapter_input__T7ZHt`,
	"select": `AddVideoChapter_select__JR5JB`,
	"submitButton": `AddVideoChapter_submitButton__ccYuc`,
	"loading": `AddVideoChapter_loading__FfzBx`,
	"error": `AddVideoChapter_error__PnnAg`,
	"message": `AddVideoChapter_message__LO8Ve`,
	"success": `AddVideoChapter_success__j6tNG`,
	"previewCard": `AddVideoChapter_previewCard__2zZFR`,
	"previewTitle": `AddVideoChapter_previewTitle__nlDt6`,
	"videoPreview": `AddVideoChapter_videoPreview__ZRurq`,
	"videoImage": `AddVideoChapter_videoImage__LdHWb`,
	"previewImg": `AddVideoChapter_previewImg__4mmSa`,
	"videoDetails": `AddVideoChapter_videoDetails__lxKB6`,
	"searchableSelect": `AddVideoChapter_searchableSelect__0mnZv`,
	"dropdownArrow": `AddVideoChapter_dropdownArrow__O2Nqt`,
	"open": `AddVideoChapter_open__l4nWg`,
	"dropdownList": `AddVideoChapter_dropdownList__7Kc8U`,
	"fadeIn": `AddVideoChapter_fadeIn__Mx5mV`,
	"dropdownItem": `AddVideoChapter_dropdownItem__uRQc1`
};
export default ___CSS_LOADER_EXPORT___;
